module.exports = __webpack_public_path__ + "img/19.9435192e.jpg";